(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbToDoListService', ['$http', '$q', 'gettextCatalog', 'pxUriPathService', ToDoListService]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypesService
	 * 
	 * @description
	 * Exposes methods for retrieving content types that belong to a content
	 * type group.
	 */
	function ToDoListService($http, $q, gettextCatalog, pxUriPathService) {
		
		return {
			/**
			 * @ngdoc method
			 * @name smbContentTypesService.getContentTypes
			 * @methodOf smb-app.smbContentTypesService
			 * @kind function
			 * 
			 * @description
			 * Gets all content types the belong to a content type group
			 * 
			 * @param {Number} groupId Id of the content type group
			 * 
			 * @returns {Deferred} A promise that will resolve to a collection of content types
			 */
			getDocuments: getDocuments,

			getCount: getCount
		};

		function getDocuments() {
			var uri = pxUriPathService.resolvePath('/todolist');
			return $http.get(uri)
				.then(function (response) {
					return response.data;
				});
		}

		function getCount() {
			var tagValues = [];
			var uri = pxUriPathService.resolvePath('/todolist/count');
			return $http.get(uri)
				.then(function (response) {
					return response.data;
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/toDoListService.js
// module id = 160
// module chunks = 1